import { Redirect, Stack } from "expo-router";
import { ActivityIndicator, Platform, View } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { AppShell } from "~/components/AppShell";
import { LocalDataBanner } from "~/components/LocalDataBanner";
import { usePushRegistration } from "~/features/notifications/push-registration";
import { useAuth } from "~/hooks/useAuth";
import {
  isInitialOnboardingComplete,
  ONBOARDING_PATH,
} from "~/utils/onboarding";

export default function ProtectedLayout() {
  const { session, user, loading, passwordRecoveryActive } = useAuth();

  usePushRegistration();

  if (loading) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  // On the web an account is required. On mobile a visitor with no session is a
  // guest: their tasks live on-device only until they create an account, and the
  // app is fully usable — sign-in is optional.
  if (Platform.OS === "web" && !session?.user) {
    return <Redirect href="/login" />;
  }
  if (session?.user) {
    if (passwordRecoveryActive) {
      return <Redirect href="/reset-password" />;
    }
    // Free accounts go straight in; the paywall lives at the point of hitting a
    // plan limit rather than in front of the whole app.
    if (!isInitialOnboardingComplete(user)) {
      return <Redirect href={ONBOARDING_PATH as never} />;
    }
  }

  const guest = Platform.OS !== "web" && !session?.user;
  return (
    <View style={{ flex: 1 }}>
      {guest ? <LocalDataBanner /> : null}
      <View style={{ flex: 1 }}>
        <AppShell>
          <Stack screenOptions={{ headerShown: false }} />
        </AppShell>
      </View>
    </View>
  );
}
